import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  ca_id: '',
  ca_requestdate: '',
  ca_expectdate: '',
  ca_requestby: '',
  ca_description: '',
  ca_iscanceled: 0,
  ca_ispaid: 0,
  ca_paidby: '',
  ca_paiddate: '',
  category_id: '',
  category_name: '',
  zona_id: '',
  zona_name: '',
  divisi_id: '',
  divisi_name: '',
  subdivisi_id: '',
  subdivisi_name: '',
  project_id: '',
  project_name: '',
  pettycash_id: '',
  pettycash_name: '',
  ca_isapproved1: 0,
  ca_approvedby1: '',
  ca_approveddate1: '',
  ca_isapproved2: 0,
  ca_approvedby2: '',
  ca_approveddate2: '',
  ca_penerima: '',
  ca_isclose: 0,
  ca_createdby: '',
  ca_createddate: '',
  ca_modifyby: '',
  ca_modifydate: '',
  rowid: '',
  detail: [],
  log: [],
  record: {},
  tabs: {
    detail: 'Detil',
    approval: 'Approval',
    log: 'Log',
    record: 'Record',
  },
};

const initialState = {
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  loadingMessage: '',
  error: null,
  activeTab: 0,
  detailTab: 0,
  selectedDetailId: null,
};

const fin07caSlice = createSlice({
  name: 'fin07ca',
  initialState,
  reducers: {
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    setDetailTab: (state, action) => { state.detailTab = action.payload; },
    setSelectedDetailId: (state, action) => { state.selectedDetailId = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    clearFormData: (state) => {
      state.formData = initialFormData;
      state.detailTab = 0;
      state.selectedDetailId = null;
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialFormData, ...action.payload };
      state.loading = false;
      state.error = null;
      state.selectedDetailId = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDetailError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearModuleState: (state) => {
      state.formData = initialFormData;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.activeTab = 0;
      state.detailTab = 0;
      state.selectedDetailId = null;
    },
  },
});

export const {
  setActiveTab,
  setDetailTab,
  setSelectedDetailId,
  setDataList,
  setTotalData,
  setLoading,
  setLoadingMessage,
  setErrorMsg,
  updateFormData,
  clearFormData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  clearModuleState,
} = fin07caSlice.actions;

export default fin07caSlice.reducer;
